<template>
  <v-form ref="handedOverToPartnerForm">
    <v-row>
      <v-col cols="12">
        <v-dialog v-model="companyDialogOpen">
          <template v-slot:activator="{ on }">
            <v-btn :color="company ? 'success' : null" block v-on="on">
              <template v-if="!company"> Wybierz firmę partnerską </template>
              <template v-else> Partner: {{ company.name }} </template>
            </v-btn>
          </template>

          <v-card>
            <v-card-title> Lista firm partnerskich </v-card-title>
            <v-card-text>
              <v-text-field
                class="pt-0 mb-3"
                v-model="query"
                append-icon="mdi-magnify"
                hint="Fragment nazwy"
                persistent-hint
                hide-details
              />
              <v-data-table
                :headers="headers"
                :items="companies"
                :loading="loading"
                :search="query"
                class="row-pointer"
                hide-default-footer
                @click:row="
                  (target) => {
                    company = target;
                    companyDialogOpen = false;
                  }
                "
              >
                <template v-slot:item.premium="{ item }">
                  {{ getYesNoName(item.premium) }}
                </template>
              </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="
                  companyDialogOpen = false;
                  company = null;
                "
              >
                Anuluj
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="priceForPartner"
          type="number"
          min="0"
          step="1"
          hint="Cena partnera"
          persistent-hint
        />
        <v-text-field
          v-model="priceForAuthor"
          type="number"
          min="0"
          step="1"
          hint="Cena dla Autora"
          persistent-hint
        />
        <v-textarea
          class="pt-0"
          v-model="notesForPartner"
          placeholder="Notatki dla Partnera"
          hint="Notatki dla Partnera"
        ></v-textarea>
        <v-textarea
          class="pt-0"
          v-model="notesForAuthor"
          placeholder="Notatki dla Autora"
          hint="Notatki dla Autora"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn
          :disabled="!company"
          :loading="submitting"
          color="primary"
          block
          @click="submit"
        >
          Przekaż
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import api from "@/services/api";
import { getYesNoName } from "@/enums/YesNo";

export default {
  props: {
    // Id of SaleOffer to be handed over.
    targetSaleOfferId: [Number, String],
  },
  data() {
    return {
      companyDialogOpen: false,
      priceForPartner: 0,
      priceForAuthor: 0,
      company: null,
      notesForAuthor: "",
      notesForPartner: "",

      query: "",
      headers: [
        { text: "Nazwa", value: "name", searchable: true, filterable: true },
        { text: "NIP", value: "nip", sortable: false },
        { text: "Adres", value: "address.address", sortable: false },
        { text: "Kod pocztowy", value: "address.postalCode", sortable: false },
        { text: "Miasto", value: "address.city", sortable: false },
        { text: "BDO", value: "bdo", sortable: false },
        { text: "Rating", value: "rating", sortable: false },
        { text: "Premium", value: "premium", sortable: false },
      ],
      companies: [],
      loading: false,
      submitting: false,
      rules: {
        company: [(value) => !!value || "Wybierz firmę z listy."],
      },
    };
  },
  computed: {},
  methods: {
    getYesNoName,
    submit() {
      this.submitting = true;
      api
        .post(
          "/api/sale-offers/" +
            this.targetSaleOfferId +
            "/hand-over-to-partner/" +
            this.company.id,
          {
            priceForPartner: this.priceForPartner,
            priceForAuthor: this.priceForAuthor,
            notesForPartner: this.notesForPartner,
            notesForAuthor: this.notesForAuthor,
          }
        )
        .then(() => {
          this.$root.$emit("notify", {
            html: "Oferta przekazana do Partnera.",
          });
          this.$router.push({name: 'sale-offers'})
        })
        .catch((error) => {
          this.$root.$emit("notifyError", {
            html: "Nie udało się przekazać oferty do Partnera.",
            error,
          });
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    load() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      const params = {
        name: this.query.length ? this.query : undefined,
        partner: true,
        limit: 500,
      };

      api
        .get("/api/companies", { params })
        .then((response) => {
          this.companies = response.data.items;
        })
        .catch((error) => {
          this.$root.$emit("notifyError", {
            html: "Nie udało się pobrać listy firm.",
            error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    companyDialogOpen(state) {
      if (state) {
        this.load();
      }
    },
  },
};
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>